//-- ******************* produccion  *******************
let urlDefault = `https://middlewarenew.nuvem.cloud/`;
let UrlSeguros = 'https://middlewarenew.nuvem.cloud/';
let UrlFinanciero = 'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/' // poner url de produccion
let urlDefaultRetorno = 'https://plugin.nuvem.cloud/'
let UrlServicios = 'https://servicios.nuvem.cloud/api/';

if (process.env.REACT_APP_MODO === 'preproduction') {
  urlDefault = 'https://middlewarenew-insurance-preprod.nuvem.cloud/';
  UrlSeguros = 'https://middlewarenew-insurance-preprod.nuvem.cloud/';
  // UrlFinanciero =""
  urlDefaultRetorno = 'http://website-preprod-pluginv2.s3-website-us-west-2.amazonaws.com/';
  // urlDominio = 'http://website-preprod-pluginv2.s3-website-us-west-2.amazonaws.com/';
  UrlServicios = 'https://servicios-pruebas.nuvem.cloud/api/';
}
if (process.env.REACT_APP_MODO === 'development') {
  UrlServicios = 'https://servicios-pruebas.nuvem.cloud/api/';
  urlDefault =
    // 'http://localhost/middlewareSegurosPlugin/';
    //'http://localhost/middlewareseguros/';
    // 'http://127.0.0.1/middlewareSegurosPlugin/';
    // 'http://nuvem-insurance-pruebas.us-east-1.elasticbeanstalk.com/';   // para humana y generali
    // "http://nuvem-insurance-pruebas.us-west-2.elasticbeanstalk.com"; // con php 7.0
    // 'https://www.nuvem.cloud/'; // url para produccion
    'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/'; // url para desarrollo con php 7.4
  // 'https://middlewarenew.nuvem.cloud/'; // url para produccion 7.4
  // 'http://localhost/middlewareseguros/'

  UrlSeguros =
    // "http://ec2-35-167-4-54.us-west-2.compute.amazonaws.com/seguros/"
    // 'https://www.nuvem.cloud/';  // produccion
    // 'https://middlewarenew.nuvem.cloud/';  // produccion 7.4
    'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/'; // desarrollo php 7.4

  /*
      URLS DE APOYO
  */

  UrlFinanciero =
    // 'http://middlewarefinancierodesarrollo.us-east-2.elasticbeanstalk.com/';
    'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/';

  urlDefaultRetorno =
    //
    'http://plugin-dev.s3-website-us-west-2.amazonaws.com/'; //desarrollo
  // 'http://plugin-v4.s3-website-us-west-2.amazonaws.com/';
  // 'https://plugin.nuvem.cloud/';   // produccion
  //'http://localhost:3000/';
} else if (process.env.REACT_APP_MODO === 'preproduction') {
  urlDefault =
    // 'http://localhost/middlewareseguros/';
    // 'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/'// url para desarrollo con php 7.4
    'http://nuvem-insurance-pre-prod74.us-east-1.elasticbeanstalk.com/'; // url para preprod con php 7.4
  // 'https://middlewarenew.nuvem.cloud/'; // url para produccion 7.4

  UrlSeguros =
    // 'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/';  // desarrollo php 7.4
    'http:nuvem-insurance-pre-prod74.us-east-1.elasticbeanstalk.com/'; // preprod php 7.4
  // 'https://middlewarenew.nuvem.cloud/';  // produccion 7.4

  /*
      URLS DE APOYO
  */

  UrlFinanciero =
    // 'http://middlewarefinancierodesarrollo.us-east-2.elasticbeanstalk.com/';
    'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/';

  urlDefaultRetorno =
    // 'http://plugin-dev.s3-website-us-west-2.amazonaws.com/';   //desarrollo
    'http://plugin-v4.s3-website-us-west-2.amazonaws.com/'; //preproduccion
  //'http://localhost:3000/'; // localhost
}
else if (process.env.REACT_APP_MODO === 'preproduction') {
  urlDefault =
    // 'http://localhost/middlewareseguros/';
    // 'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/'// url para desarrollo con php 7.4
    "https://middlewarenew-insurance-preprod.nuvem.cloud/"// url para preprod con php 7.4
  // 'https://middlewarenew.nuvem.cloud/'; // url para produccion 7.4

  UrlSeguros =
    // 'http://nuvem-insurancepruebas74-dev.us-east-1.elasticbeanstalk.com/';  // desarrollo php 7.4
    "https://middlewarenew-insurance-preprod.nuvem.cloud/"  // preprod php 7.4
  // 'https://middlewarenew.nuvem.cloud/';  // produccion 7.4

  /*
      URLS DE APOYO
  */

  UrlFinanciero =
    // 'http://middlewarefinancierodesarrollo.us-east-2.elasticbeanstalk.com/';
    'http://middlewarepruebasdesarrollo.us-west-2.elasticbeanstalk.com/';


  urlDefaultRetorno =
    // 'http://plugin-dev.s3-website-us-west-2.amazonaws.com/';   //desarrollo
    'https://pluginv2-dev-website.nuvem.cloud/'; //preproduccion
  //'http://localhost:3000/'; // localhost
}

export const UrlBase = process.env.REACT_APP_URL_BASE || urlDefault;
export const UrlBaseFinanciero = UrlFinanciero;

export const UrlImagenes = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlSubirArchivo = 'https://s3-us-west-2.amazonaws.com/middleware-images/';
export const urlDocumentosPlugin = 'https://plugin-documentos.s3.us-west-2.amazonaws.com/';

export const URL_PLUGIN = `${UrlBase}backend/web/index.php?r=plugin/`;
export const URL_PLUGIN_FRONTEND = `${UrlBase}frontend/web/index.php?r=plugin/`;
export const URL_PLUGIN_PROD = `${UrlBase}backend/web/index.php?r=plugin/`; // talvez eliminar
export const URL_PLUGIN_SEGUROS = `${urlDefault}frontend/web/index.php?r=plugin/`;
export const URL_EDIT_VIGENCIA_COTIZACION = `${URL_PLUGIN}edit-vigencia-cotizacion`;
export const UrlBaseServicios = UrlServicios;

export const URL_RETORNO = process.env.REACT_APP_URL_RETORNO || urlDefaultRetorno;
